import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import { Icon, RowView } from "../../../../Component/style/common_style";

const Detail_itemInsert = (props: {
  updateChnage: () => void;
  live_finish: string;
}) => {
  const { seq } = useParams();
  const updateChnage = props.updateChnage;
  const live_finish = props.live_finish;

  // 지난 방송상품 불러오기
  const [lastLiveList, setLastLiveList] = useState<
    {
      live_start: string;
      seq: number;
      live_title: string;
    }[]
  >([]);
  const [product_num, setProduct_num] = useState<number | null>(null);
  const [name, setName] = useState("");
  const [price, setPrice] = useState<number | null>(null);
  const [init_cnt, setInit_cnt] = useState<number | null>(null);

  const setting_pnum = (e: React.ChangeEvent<HTMLInputElement>) =>
    setProduct_num(Number(e.target.value));
  const setting_name = (e: React.ChangeEvent<HTMLInputElement>) =>
    setName(e.target.value);
  const setting_price = (e: React.ChangeEvent<HTMLInputElement>) =>
    setPrice(Number(e.target.value));
  const setting_init_cnt = (e: React.ChangeEvent<HTMLInputElement>) =>
    setInit_cnt(Number(e.target.value));

  const last_live_list = async () => {
    try {
      const res = await api.get(url.Communication_url.last_live_list);
      setLastLiveList(res.data || []);
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };
  useEffect(() => {
    last_live_list();
  }, []);

  // 상품등록
  const [itemboxOpen, setItemboxOpen] = useState(false);
  const open_itembox = () => setItemboxOpen(true);
  const close_itembox = () => setItemboxOpen(false);
  const boxopen_class = () => {
    if (itemboxOpen) return "open";
    return "";
  };
  const setting_selectItem = async (last_live_seq: number) => {
    if (new Date() > new Date(live_finish)) {
      alert(
        "완전히 종료된 방송입니다.\n해당 방송엔 상품을 등록할 수 없습니다."
      );
      return;
    }
    if (!window.confirm("해당 방송의 상품을 모두 등록하시겠습니까?")) {
      return;
    }

    try {
      const res = await api.post(
        url.Communication_url.create_last_live_product,
        {
          live_seq: seq,
          last_live_seq: last_live_seq,
        }
      );

      if (res.data === "성공") {
        alert("상품이 등록 되었습니다.");
        close_itembox();
        updateChnage(); // 상품 목록 reload
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  const dropdownRef = useRef<HTMLDivElement>(null);
  const closeDropdown = (e: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node))
      return close_itembox();
  };
  useEffect(() => {
    document.addEventListener("mousedown", closeDropdown);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
    };
  }, []);

  const insert_product = async () => {
    if (name === "" || init_cnt === null || init_cnt === null) {
      alert("상품정보를 정확히 입력해주세요.");
      return;
    }

    try {
      const res = await api.post(url.Communication_url.product_create, {
        live_seq: seq,
        product_num: product_num,
        name: name,
        price: price,
        init_cnt: init_cnt,
      });

      if (res.data.includes("성공")) {
        alert("추가되었습니다.");
        setProduct_num(null);
        setName("");
        setPrice(null);
        setInit_cnt(null);
        updateChnage(); // 상품 목록 reload
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  // 엑셀 업로드
  const xlxsRef = useRef<HTMLInputElement>(null);
  const openFile = () => {
    if (xlxsRef.current) {
      xlxsRef.current.click();
    }
  };
  const upload_xlxs = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) {
      return;
    }
    const extension = files[0].name.split(".").pop()?.toLowerCase();
    if (files && extension !== "xlsx" && extension !== "xls") {
      alert(".xlsx 파일만 첨부가능합니다.");
      return;
    }
    try {
      const res = await api.post(
        url.Communication_url.product_excel_upload,
        {
          live_seq: seq,
          file: files[0],
        },
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data === "성공") {
        updateChnage(); // 상품 목록 reload
      } else {
        alert("엑셀 업로드 실패");
      }
    } catch (error) {
      alert("엑셀 업로드 실패");
      console.error("엑셀 실패:", error);
    }
  };

  return (
    <>
      <Select ref={dropdownRef}>
        <ItemBox className={boxopen_class()} onClick={open_itembox}>
          <div className="gray">지난 방송상품 불러오기</div>
          {!itemboxOpen && (
            <Icon src={require("../../../../Image/ic_down_black.png")} />
          )}
        </ItemBox>

        <ItemList className={boxopen_class()}>
          {lastLiveList.length === 0 ? (
            <div>지난 방송이 없습니다.</div>
          ) : (
            lastLiveList.map((data, idx) => {
              const date = data.live_start.slice(0, 10).replaceAll("-", ".");
              return (
                <div
                  key={idx}
                  style={idx === 0 ? { borderTop: 0 } : {}}
                  onClick={() => setting_selectItem(data.seq)}
                >
                  {date} / {data.live_title}
                </div>
              );
            })
          )}
        </ItemList>
      </Select>

      <InsertItem className="bottom">
        <div style={{ maxWidth: "5rem" }}>
          <div>번호</div>
          <InputBox
            type={"number"}
            placeholder="-"
            value={product_num ?? ""}
            onChange={setting_pnum}
            min={0}
          />
        </div>
        <div>
          <div>상품명</div>
          <InputBox placeholder="-" value={name} onChange={setting_name} />
        </div>
        <div style={{ maxWidth: "8rem" }}>
          <div>가격</div>
          <InputBox
            type={"number"}
            placeholder="-"
            value={price || ""}
            onChange={setting_price}
          />
        </div>
        <div style={{ maxWidth: "8rem" }}>
          <div>재고</div>
          <InputBox
            type={"number"}
            placeholder="-"
            value={init_cnt ?? ""}
            onChange={setting_init_cnt}
          />
        </div>
        <span onClick={insert_product}>추가</span>
        <span className="white" onClick={openFile}>
          엑셀 업로드
        </span>

        <input
          type={"file"}
          ref={xlxsRef}
          onChange={upload_xlxs}
          style={{ display: "none" }}
        />
      </InsertItem>
    </>
  );
};
export default Detail_itemInsert;

const Select = styled.div`
  position: relative;
`;
const ItemBox = styled(RowView)`
  padding: 0.8rem 1rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  div.gray {
    color: #8e8e8e;
  }
  &.open {
    border-radius: 8px 8px 0px 0px;
    border-bottom: 0;
  }
`;
const ItemList = styled.div`
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 29rem;
  background-color: white;
  border-top: 0;
  border: 1px solid #f0f0f0;
  overflow: auto;
  cursor: pointer;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    &:hover {
      background: #ababab;
    }
  }
  div {
    padding: 0.8rem 1rem;
    border-top: 1px solid #f0f0f0;
    &:hover {
      background-color: #f8f8f8;
    }
  }
  &.open {
    display: block;
  }
`;
const InsertItem = styled(RowView)`
  margin-top: 1rem;
  margin-bottom: 4rem;
  div {
    flex: 1;
    margin-right: 0.5rem;
  }
  input {
    margin-top: 0.5rem;
  }
  span {
    padding: 0.8rem 1.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
  span.white {
    padding: 0.8rem 1.5rem;
    margin-left: 0.5rem;
    white-space: nowrap;
    ${fontStyles.semiBold}
    color: #2d2d2d;
    background-color: white;
    border: 1px solid #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const InputBox = styled.input`
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  padding: 0.8rem;
  ${fontStyles.regular}
  font-size: 16px;
  border: 1px solid #f0f0f0;
  outline: 0;
  border-radius: 8px;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
  &::placeholder {
    color: #c6c6c6;
  }
  &.search {
    min-width: 20rem;
  }
`;
